import { alpha, Divider, Stack, styled, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import AddNewAppDialog from "src/layouts/dialogs/AddNewAppDialog/AddNewAppDialog";
import { AppType } from "src/types/apps";

import DashContext, { ContextType } from "../../context";
import EmptyApps from "./components/EmptyApps";
import TypeNameApp from "./components/TypeNameApp";
import Context from "./context";
import SelectAppMenu from "./SelectAppMenu/SelectAppMenu";
import useAppSectionActionsStore from "./store";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
	display: "inline-flex",
	cursor: "pointer",
	padding: theme.spacing(3, 2.5),
	overflow: "hidden",
	alignItems: "center",
	backgroundColor: theme.palette.background.paper,
	":hover": {
		backgroundColor: alpha(theme.palette.grey[500], 0.12)
	}
}));

type Props = {};

export default function NavbarAppSection({}: Props) {
	const [state, actions] = useAppSectionActionsStore();

	const { isCollapse }: ContextType = useContext<ContextType>(DashContext);
	const theme = useTheme();
	const { data: apps } = useQuery<AppType[]>({ queryKey: ["apps"], initialData: [] });

	const isEmpty = apps.length === 0;

	const handleOnClose = () => {
		actions.hideAddNewAppDialog();
	};

	const handleOnClickSection = (event: any) => {
		isEmpty ? actions.showAddNewAppDialog() : actions.showSelectAppMenu(event.currentTarget);
	};

	return (
		<Context.Provider value={{ actions, state }}>
			<Divider sx={{ pt: 12, borderStyle: "dashed" }} />
			<StyledRoot
				onClick={handleOnClickSection}
				sx={{ justifyContent: isCollapse ? "center" : "space-between" }}
			>
				{isCollapse && (
					<Stack>
						<Iconify
							icon={isEmpty ? "charm:apps-plus" : "uil:apps"}
							ml='auto'
							width={22}
							height={22}
							color={theme.palette.grey[700]}
						/>
					</Stack>
				)}
				{!isCollapse && (isEmpty ? <EmptyApps /> : <TypeNameApp />)}
			</StyledRoot>
			<Divider sx={{ borderStyle: "dashed" }} />
			<AddNewAppDialog onClose={handleOnClose} show={state.showAddNewAppDialog} />
			<SelectAppMenu />
		</Context.Provider>
	);
}
